import abcLogo from '../../assets/images/roadTransports/abc.svg';
import chiscoLogo from '../../assets/images/roadTransports/chisco.svg';
import gigLogo from '../../assets/images/roadTransports/gig.svg';
import guoLogo from '../../assets/images/roadTransports/guo.svg';
import libraLogo from '../../assets/images/roadTransports/libra.svg';
import buupassLogo from '../../assets/images/roadTransports/buupass-lg.webp';

import threeSeater from '../../assets/images/bus/3-seater.png';
import sixSeater from '../../assets/images/bus/6-seater.png';
import fifteenSeater from '../../assets/images/bus/15-seater.png';
import fiftyTwoSeater from '../../assets/images/bus/52-seater.png';

export const getRoadTransportLogo = (name: string) => {
  const lower = name.toLowerCase();

  if(lower.includes('buupass')){
    return buupassLogo
  }
  if (lower.includes('chisco')) {
    return chiscoLogo;
  }
  if (lower.includes('abc')) {
    return abcLogo;
  }
  if (lower.includes('gig')) {
    return gigLogo;
  }
  if (lower.includes('guo')) {
    return guoLogo;
  }
  if (lower.includes('libra')) {
    return libraLogo;
  }

  // fallback
  return abcLogo;
};

export const getBusTypeImage = (seat: number) => {
  if (seat <= 3) {
    return threeSeater;
  } if (seat <= 6) {
    return sixSeater;
  } if (seat <= 15) {
    return fifteenSeater;
  }
  return fiftyTwoSeater;
};

export const calculateTotalFare = (selectedBus: AvailableBus[], numberOfPassengers: number) => {
  if(!selectedBus) {
    return { totalCharges: 0, totalAmount: 0, ticketAmount: 0 };
  }
  const totalAmount = numberOfPassengers * selectedBus.reduce((acc, item) => (acc + item.TotalFare), 0);
  return { totalCharges: 0, totalAmount, ticketAmount: totalAmount };
};

export const calculateRoadFareBreakdown = (selectedBus: AvailableBus[] | null): FlightPassengerFare[]  => {
  if (!selectedBus) {
    return [];
  }


  let departurePassengerFares  = selectedBus[0].PassengerFares;
  let totalFares = [...departurePassengerFares]
  const returningPassengerFares  = selectedBus[1] ? selectedBus[1].PassengerFares : null;

  if(returningPassengerFares) {
    totalFares.push(...returningPassengerFares)
  }

  return totalFares;
};

export type SelectedSeatBreakdownItem = {
  class: string;
  seatNumbers: string[];
  totalPrice: number;
};

export const getSelectedSeatsBreakdown = (seats: AvailableSeat[], legFare: number = 0): SelectedSeatBreakdownItem[] => {
  if (!seats || seats.length === 0) return [];
  
  const groups: { [key: string]: { seatNumbers: string[], totalPrice: number } } = {};
  
  const capitalizeClass = (className: string) => {
    if (!className) return "Normal";
    const lower = className.toLowerCase();
    if (lower === "vip") return "VIP";
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  seats.forEach(seat => {
    const cls = capitalizeClass(seat.Class);
    if (!groups[cls]) {
      groups[cls] = { seatNumbers: [], totalPrice: 0 };
    }
    groups[cls].seatNumbers.push(seat.SeatNumber);
    groups[cls].totalPrice += seat.Price || legFare;
  });

  const order = ["Normal", "Business", "VIP"];
  const sortedClasses = Object.keys(groups).sort((a, b) => {
    const idxA = order.indexOf(a);
    const idxB = order.indexOf(b);
    if (idxA !== -1 && idxB !== -1) return idxA - idxB;
    if (idxA !== -1) return -1;
    if (idxB !== -1) return 1;
    return a.localeCompare(b);
  });

  return sortedClasses.map(cls => {
    const sortedSeats = [...groups[cls].seatNumbers].sort((a, b) => {
      const numA = parseInt(a, 10);
      const numB = parseInt(b, 10);
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
      return a.localeCompare(b);
    });
    return {
      class: cls,
      seatNumbers: sortedSeats,
      totalPrice: groups[cls].totalPrice
    };
  });
};

export const formatSelectedSeats = (seats: AvailableSeat[]) => {
  const breakdown = getSelectedSeatsBreakdown(seats);
  return breakdown.map(item => `${item.class} (${item.seatNumbers.join(", ")})`).join(", ");
};


